import axios from 'axios';
import {TOKEN_EXPIRED} from "../hooks/useAPIHelper";


const GET_ACTION_CODE = '/.netlify/functions/serviceGetCallActionCodes';

const GetCallActionTypeCode = (token: string) => {

  const fetchData = async(): Promise<any> => {
    try {
      const actionTypeResponse = await axios.post(GET_ACTION_CODE, '', {
        headers:{
          'Content-Type': 'application/json',
          'X-Pronto-Token': token,
        }
      });

      if(actionTypeResponse.status == 200) {
        let data = actionTypeResponse.data.ServiceGetCallActionCodesResponse.ServiceCallActionCodes.ServiceCallActionCode;
        if(data == undefined || data.length == 0) {
          return [];
        } else {
          return data
        }
      }
    } catch (err) {
      if(err.response.status == 401) {
        if(err.response.data == 'TokenExpired') {
          throw(TOKEN_EXPIRED)
        }
      }
    }
  };

  return fetchData()
};

export default GetCallActionTypeCode;